// frontend/src/Pages/FAQ.jsx
import React from 'react';
import { 
  Container, 
  Typography, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Box, 
  Paper 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqs = [
  { q: "What is this website and how does it work?", a: "SeekDeals is a platform that helps users discover exclusive deals, discounts, and offers from nearby local vendors. Simply visit the website, sign up, browse the available deals, and redeem them directly at the vendor’s shop. We only display the deals, and all offers are created and managed by the vendors." },
  { q: "How often are new deals added?", a: "New deals are added regularly based on vendor availability. Vendors can update their deals directly from their accounts, and many of them refresh their offers daily or weekly." },
  { q: "Can local vendors add their deals directly through the website?", a: "Yes. Vendors can register through our vendor portal, submit their deals, and manage their offers in real time." },
  { q: "Whom should I contact if I face an issue with a deal or vendor?", a: "You can reach our support team through the “Help & Support” section in the app or email us directly. We aim to resolve all issues as quickly as possible." },
  { q: "Is the site free to use?", a: "Yes, the website is completely free for users. You can explore deals without any hidden charges." },
  { q: "Can I search deals by category or specific items?", a: "Absolutely. You can filter deals by categories like food, fashion, electronics, services, and more." },
  { q: "How do I use the website to find deals near me?", a: "Just open the website and allow location access. You’ll instantly see deals from local vendors around your area." },
  { q: "Do I need an account to see the deals?", a: "Yes. A simple login is required to view all the deals. Once you sign in, you can browse offers easily." }
];

const FAQ = () => {
  return (
    <Box sx={{ minHeight: '700px', display: 'flex', alignItems: 'center', bgcolor: '#F8FAFC', py: 6 }}>
      <Container maxWidth="lg">
        <Paper elevation={6} sx={{ p: { xs: 4, md: 5 }, borderRadius: 3 }}>
          {/* Header matching Contact/Terms style */}
          <Box textAlign="center" mb={4}>
            <Typography variant="h4" fontWeight={700} color="#1a7f3a" gutterBottom>
              Frequently Asked Questions
            </Typography>
            <Typography color="text.secondary">
              Everything you need to know about SeekDeals
            </Typography>
          </Box>

          {/* FAQ List */}
          {faqs.map((item, index) => (
            <Accordion 
              key={index} 
              sx={{ 
                mb: 1, 
                '&:before': { display: 'none' }, 
                boxShadow: 'none', 
                border: '1px solid #E5E7EB',
                borderRadius: '8px !important',
                '&.Mui-expanded': { margin: '0 0 8px 0' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#1a7f3a' }} />}>
                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                  {item.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 0 }}>
                <Typography color="text.secondary">
                  {item.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Container>
    </Box>
  );
};

export default FAQ;